import React, { useRef, useState } from 'react';
import { COLOR_TOKEN } from '../../constants/styles-constants';

interface Props {
	slides: React.ReactNode[];
	lentilsNavigation?: boolean;
	onChange?: (slideIndex: number) => void;
}

export function Carousel(props: Props) {
	const { slides, lentilsNavigation, onChange } = props;
	const [currentSlide, setCurrentSlide] = useState(0);

	const innerRef = useRef<HTMLDivElement>(null);

	const handleNext = () => {
		if (currentSlide < slides.length - 1) {
			const nextSlide = currentSlide + 1;
			setCurrentSlide(nextSlide);
			onChange?.(nextSlide);
		}
	};

	const Lentils = ({ currentSlide }: { currentSlide: number }) => {
		return (
			<div
				style={{
					display: 'flex',
					gap: '8px',
					justifyContent: 'center',
					alignItems: 'center',
					paddingTop: '20px',
					paddingBottom: '40px',
				}}
			>
				{Array.from({ length: slides.length }).map((_, i) => (
					<div
						key={i}
						style={{
							width: 10,
							height: 10,
							cursor: lentilsNavigation ? 'pointer' : 'default',
						}}
						onClick={(e) => {
							e.preventDefault();
							if (lentilsNavigation) {
								setCurrentSlide(i);
							}
						}}
					>
						<div
							key={i}
							style={{
								width: '100%',
								height: '100%',
								borderRadius: '50%',
								backgroundColor: COLOR_TOKEN.background.primary,
								transform: i === currentSlide ? 'scale(1)' : 'scale(0.5)',
								transition: 'transform 0.3s ease',
							}}
						/>
					</div>
				))}
			</div>
		);
	};

	return (
		<>
			<div
				style={{
					position: 'relative',
					overflow: 'hidden',
					width: '100%',
					height: 'auto',
					transition: 'height 0.3s ease',
				}}
			>
				<div
					ref={innerRef}
					style={{
						display: 'flex',
						transform: `translateX(-${currentSlide * 100}%)`,
						transition: 'transform 0.3s ease-in-out',
						width: '100%',
						alignItems: 'flex-start',
					}}
				>
					{slides.map((slide, index) => (
						<div
							key={index}
							style={{
								minWidth: '100%',
								width: '100%',
								flexShrink: 0,
								boxSizing: 'border-box',
								paddingBottom: '10px',
							}}
							onClick={(e) => {
								if ((e.target as HTMLElement).closest('[data-on-click]')) {
									handleNext();
								}
							}}
						>
							{slide}
						</div>
					))}
				</div>
			</div>

			{slides.length > 1 && <Lentils currentSlide={currentSlide} />}
		</>
	);
}
